import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import Home from './page/admin/home/page';
import Layout from './page/admin/layout';
import Product from './page/admin/product/page';
import About from './page/admin/about/page';

function App() {
  return (
    <Router>
      <Routes>
        {/* Sử dụng Layout chung cho tất cả các trang */}
        <Route element={<Layout />}>
          <Route path="/" element={<Home />} />
          <Route path="/products" element={<Product />} />
          <Route path="/about" element={<About />} />
          {/* Thêm các route khác ở đây sau */}
          {/* <Route path="/about" element={<About />} /> */}
          <Route path="*" element={<Navigate to="/" replace />} />
        </Route>
      </Routes>
    </Router>
  );
}

export default App;